'use client';

import { ReactNode, useMemo } from 'react';

import * as Popover from '@radix-ui/react-popover';

import styles from './BurgerMenu.module.scss';

export interface BurgerMenuItem {
  key: string;
  component: ReactNode;
  onClickAction: () => void;
  disabled?: boolean;
}

interface BurgerMenuProps {
  trigger: ReactNode;
  items: BurgerMenuItem[];
  side?: 'left' | 'right' | 'top' | 'bottom';
}

export const BurgerMenu = ({ items, trigger, side = 'bottom' }: BurgerMenuProps) => {
  const Actions = useMemo(() => {
    return items.map(({ component, onClickAction, key, disabled }) => {
      return (
        <button key={key} className={styles['dropdown-list-item']} onClick={onClickAction} disabled={disabled}>
          {component}
        </button>
      );
    });
  }, [items]);

  return (
    <Popover.Root>
      <Popover.Trigger className={styles['custom-popover-trigger']} asChild>
        {trigger}
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content side={side} sideOffset={5} className={styles['custom-modal']}>
          <div className={styles['dropdown-list']}>{Actions}</div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
